<!-- Define some CSS styles for the map and layer list -->

<style>
	#map {
		height: 88vh;
	}

	.layers {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding: 10px;
		gap: 10px;
	}

	ul {
		list-style-type: none;
		background-color: #f1f1f1;
	}

	:global(.material-icons) {
		font-size: 21px;
	}

	:global(.leaflet-popup-close-button) {
		display: none;
	}

    :global(.custom-tooltip) {
        background: green;
        color: white;
        border-radius: 50px;
        font-size: 12px;
        padding: 0px;
        border: none;
        box-shadow: none;
    }

    :global(.custom-tooltip .material-icons) {
        font-size: 16px; 
        vertical-align: middle; 
    }

	:global(.leaflet-retina .leaflet-control-layers-toggle) {
		background-image: url('./assets/images/layers-2x.png');
	}

	:global(.leaflet-draw-toolbar a) {
		background-image: url('./assets/images/spritesheet.png');
		background-image: linear-gradient(transparent, transparent), url('./assets/images/spritesheet.svg');
	}

	:global(.leaflet-retina .leaflet-draw-toolbar a) {
		background-image: url('./assets/images/spritesheet-2x.png');
		background-image: linear-gradient(transparent, transparent), url('./assets/images/spritesheet.svg');
	}
	/*
	:global(.leaflet-draw a .sr-only) {
		border-bottom-left-radius: 2px;
		border-bottom-right-radius: 2px;
		border: 1px solid black;
		width: max-content;
		height: unset;
		background: #fff;
		margin-left: 16px;
		clip: unset;
		padding-left: 2px;
    	padding-right: 2px;
	}
	*/
</style>

<script>
	import * as L from 'leaflet';
	import 'leaflet-draw';
	import 'leaflet-draw/dist/leaflet.draw.css';
	import 'leaflet-iconmaterial';
	import 'leaflet.featuregroup.subgroup';
	import 'leaflet/dist/leaflet.css';

    window.type = true;

	import { colorIsDifferent, getRandomColor } from '../../../../../shared/functions';

	import { onMount } from 'svelte';
	import MapLoading from '../../../../../shared/components/common/Loading/MapLoading.svelte';
	import { hasRoleAreaManager, hasRoleCompanyManager, hasRoleSysAdmin, userSession } from './../../../../../shared/stores.ts';

	// Get list of companies and organizations
    export let data;
    
	// Filter office addresses to get those belonging to companies/organizations
    $: dataIndirizziAziendeEnti = $data?.response?.map(a => a.sedi).flat().filter(x => !x.scuola && x.indirizzoOK) || [];

	// Filter office addresses to get those belonging to schools
    $: dataIndirizziScuole = $data?.response?.map(a => a.sedi).flat().filter(x => x.scuola && x.indirizzoOK) || [];

	// Set loadingMap to true initially
	let loadingMap = true;

	// When the component mounts, wait for a short time and then set loadingMap to false
	onMount(async () => {
		setTimeout(() => {
			loadingMap = false;

			// Get the first office address from the list of office addresses
			const firstSede = $data?.response?.sedi?.[0];

			// Set default coordinates if no office address is available
			const defaultCoords = [46.4982953, 11.3547582];

			// Set the map center coordinates to the first office address or the default coordinates
			const coords = firstSede ? [firstSede.latitude, firstSede.longitude] : defaultCoords;

			// Create a Leaflet map object with max zoom level of 18 and set the view to the center coordinates
			const map = L.map('map', {
				maxZoom: 18,
			}).setView(coords, 7);

			// Set the tile layer URL and attribution
			const tileLayerUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
			const tileLayerAttribution = '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';

			// Add the tile layer to the map
			L.tileLayer(tileLayerUrl, {
				attribution: tileLayerAttribution,
			}).addTo(map);

            var drawnItems = new L.FeatureGroup();
            map.addLayer(drawnItems);

            var drawControl = new L.Control.Draw({
                draw: {
                    polygon: true,
                    polyline: false,
                    rectangle: true,
                    circle: false,
                    marker: false,
					circlemarker: false
                },
                edit: {
                    featureGroup: drawnItems,
                    edit: false,
					remove: false
                }
            });
            map.addControl(drawControl);

            map.on('draw:created', function (e) {
                var layer = e.layer;
                drawnItems.addLayer(layer);

                if (layer instanceof L.Polygon) {
                    selectMarkersInPolygon(layer);
                    setTimeout(function() {
                        drawnItems.removeLayer(layer);
                    }, 10);
                }
            });

			function selectMarkersInPolygon(polygon) {
				map.eachLayer(function(layer) {
					if (layer instanceof L.Marker) {
						if (polygon.getBounds().contains(layer.getLatLng())) {
							selectMarker(layer);
						}
					}
				});
			}
			// Define an object that maps layer types to Leaflet Material Design icons with specified colors and outlines
			const layerIcons = {
				school: L.IconMaterial.icon({
					icon: 'school',
					iconColor: '#fff',
					markerColor: '#3388ff',
					outlineColor: 'black',
					outlineWidth: 1,
				}),
				domain: L.IconMaterial.icon({
					icon: 'domain',
					iconColor: '#fff',
					markerColor: '#3388ff',
					outlineColor: 'black',
					outlineWidth: 1,
				}),
			};

			// Create a Leaflet control for layer selection with collapsed state based on whether the user has the Company Manager role
			var layerControl = L.control.layers(null, null, {
				collapsed: $hasRoleCompanyManager ? false : true,
			});
			
            function selectMarker(e) {
                let currentMarker = e.target ? e.target : e;

				if (currentMarker.sedeData) {
					if (currentMarker?.sedeData?.selected) {
						resetMarkerStyle(currentMarker);
						currentMarker.sedeData.selected = false;
						updateSedeSelectedStatus(currentMarker.sedeData.id, false);
					} else {
						setMarkerAsSelected(currentMarker);
						currentMarker.sedeData.selected = true;
						updateSedeSelectedStatus(currentMarker.sedeData.id, true);
					}
				}
            }

            function resetMarkerStyle(marker) {
                if (marker.getTooltip()) {
                    marker.unbindTooltip();
                }
                marker.setIcon(L.IconMaterial.icon({
                    ...marker.options.icon.options,
					outlineColor: 'black',
                    outlineWidth: 1,
                }));
            }

            function setMarkerAsSelected(marker) {
                marker.bindTooltip('<i class="material-icons">check</i>', {
                    permanent: true,
                    className: 'custom-tooltip',
                    offset: L.point(-30, -35)
                }).openTooltip();
                marker.setIcon(L.IconMaterial.icon({
                    ...marker.options.icon.options,
					outlineColor: 'green',
                    outlineWidth: 3,
                }));
            }

            function updateSedeSelectedStatus(sedeId, isSelected) {
                data.update(allData => {
                    let newData = {...allData};
                    newData.response = newData.response.map(azienda => {
                        azienda.sedi = azienda.sedi.map(sede => {
                            if (sede.id === sedeId) {
                                return {...sede, selected: isSelected};
                            }
                            return sede;
                        });
                        return azienda;
                    });
                    return newData;
                });
            }

			var markerGroup = new L.featureGroup().addTo(map);

            function createMarker(latitude, longitude, icon, popupContent, groupKey, sedeData) {
                var marker = L.marker([Number(latitude), Number(longitude)], { icon, groupKey }).addTo(markerGroup);;

				if (typeof sedeData.selected === 'undefined') {
					sedeData.selected = false;
				}
				
                if (sedeData?.selected) {
                    marker.bindTooltip('<i class="material-icons">check</i>', {
                        permanent: true,
                        className: 'custom-tooltip',
                        offset: L.point(-30, -35)
                    });

                    marker.bindPopup(popupContent);
                }

                marker.sedeData = sedeData;
                marker.on('click', selectMarker);
                marker.openTooltip();

                return marker;
            }

			const usedColors = {};

			function getUniqueRandomColor(usedColors, initialThreshold = 10, maxAttempts = 1000) {				
				let uniqueColor = getRandomColor();
				let isDifferent = false;
				let attempts = 0;
				let threshold = initialThreshold;

				// Loop until a unique color is found or the maximum number of attempts is reached
				while (!isDifferent && attempts < maxAttempts) {
					try {
						// Check if the new color is different from all existing layer colors and used colors
						isDifferent =
							usedColors.every((usedColor) => colorIsDifferent(uniqueColor, usedColor, threshold));
					
					} catch (error) {
						console.error(error);
					}

					attempts++;
					
					// If the color is not unique, generate a new one and increment the attempts counter
					if (!isDifferent) {
						uniqueColor = getRandomColor();

						// Decrease the threshold as the number of attempts increases
						if (attempts % Math.floor(maxAttempts / 10) === 0 && threshold > 0) {
							threshold--;
						}
					}
				}

				return uniqueColor;
			}

			const colorsBySede = dataIndirizziAziendeEnti?.reduce((acc, { id, colore }) => {
				const uniqueColor = getUniqueRandomColor(Object.values(usedColors));
				acc[id] = colore || uniqueColor;
				if (!colore) {
					usedColors[id] = uniqueColor;
				}
				return acc;
			}, {});

			function getArrayOfMarkers(overlay, sede = '', groupKey = '') {
				let result = [];
				let featureGroup = L.featureGroup();
				switch (overlay) {
					case 'company':
						result = dataIndirizziAziendeEnti?.map(
							sede => {
								const nomeAzienda = !$data?.response?.length > 0
									? $data?.response?.find((x) => x.id === sede.aziendaEnteId)?.nomeAziendaEnte ?? ''
									: '';
								const popup = `
									Nome Azienda: ${nomeAzienda}</br>
									Denominazione: ${sede.denominazione ? sede.denominazione + ' ' : ''}</br>
									Indirizzo: ${sede.provincia ? sede.provincia + ',' : ''} ${sede.citta ? sede.citta + ',' : ''} ${sede.indirizzo}
								`;
								const originalIcon = layerIcons.domain;
								const icon = L.IconMaterial.icon({
									...originalIcon.options,
									markerColor: colorsBySede[sede.id],
                                    outlineColor: sede?.selected ? 'green' : 'black',
                                    outlineWidth: sede?.selected ? 3 : 1,
								});
								return createMarker(sede.latitude, sede.longitude, icon, popup, groupKey, sede);
							}
						);
						break;
					case 'school':
						result = dataIndirizziScuole?.map(sede => {
							const nomeAzienda = !$data?.response?.length > 0
								? $data?.response?.find((x) => x.id === sede.aziendaEnteId)?.nomeAziendaEnte ?? ''
								: '';
							const popup = `
								Nome Azienda: ${nomeAzienda}</br>
								Denominazione: ${sede.denominazione ? sede.denominazione + ' ' : ''}</br>
								Indirizzo: ${sede.provincia ? sede.provincia + ',' : ''} ${sede.citta ? sede.citta + ',' : ''} ${sede.indirizzo}
							`;

                            const originalIcon = layerIcons.school;
								const icon = L.IconMaterial.icon({
									...originalIcon.options,
									markerColor: colorsBySede[sede.id],
                                    outlineColor:  sede?.selected ? 'green' : 'black', 
                                    outlineWidth: sede?.selected ? 3 : 1,
								});
							return createMarker(sede.latitude, sede.longitude, icon, popup, groupKey, sede);
						});
						break;
				}
				map.addLayer(featureGroup);
				return featureGroup;
			}

			const overlays = {
				...($hasRoleSysAdmin || $hasRoleAreaManager
					? {
						'Sedi aziendali': getArrayOfMarkers('company', '', '').addTo(map),
						'Sedi scolastiche': getArrayOfMarkers('school', '', '').addTo(map),
					}
					: {
						['Sedi ' + ($userSession?.scuola ? 'scolastiche' : 'aziendali')]: getArrayOfMarkers($userSession?.scuola ? 'school' : 'company', '', '').addTo(map),
					}),
			};

			function createColorIcon(color) {
				const icon = document.createElement('span');
				icon.style.display = 'inline-block';
				icon.style.width = '12px';
				icon.style.height = '12px';
				icon.style.backgroundColor = color;
				icon.style.marginRight = '4px';
				icon.style.marginLeft = '8px';
				icon.style.border = '1px solid #888';
				return icon;
			}

			L.Control.ColorLayers = L.Control.Layers.extend({
				_addItem: function (obj) {
					const container = obj.overlay ? this._overlaysList : this._baseLayersList;
					const label = document.createElement('label');
					const checked = this._map.hasLayer(obj.layer);
					let input;

					if (obj.layer.getLayers) {
						input = document.createElement('input');
						input.type = 'checkbox';
						input.className = 'leaflet-control-layers-selector';
						input.defaultChecked = checked;
					} else {
						input = this._createRadioElement('leaflet-base-layers', checked);
					}

					this._layerControlInputs.push(input);
					input.layerId = L.stamp(obj.layer);
					L.DomEvent.on(input, 'click', this._onInputClick, this);

					const name = document.createElement('span');
					name.innerHTML = ' ' + obj.name;

					label.appendChild(input);
					label.appendChild(name);

					if (obj.layer.options && obj.layer.options.color) {
						const colorIcon = createColorIcon(obj.layer.options.color);
						label.appendChild(colorIcon);
					}

					if (obj.overlay) {
						container.appendChild(label);
					} else {
						container.insertBefore(label, container.firstChild);
					}

					return label;
				},
			});

			// Create a Leaflet layer control with the overlays object and add it to the map
			// Sord overlays by name
			const sortedOverlays = Object.entries(overlays)
			.sort(([keyA], [keyB]) => {
				const numA = parseInt(keyA.match(/^\D*(\d+)/)?.[1] ?? 0);
				const numB = parseInt(keyB.match(/^\D*(\d+)/)?.[1] ?? 0);
				if (numA === numB) {
				return keyA.localeCompare(keyB);
				} else {
				return numA - numB;
				}
			})
			.reduce((acc, [key, value]) => {
				acc[key] = value;
				return acc;
			}, {});

			layerControl = new L.Control.ColorLayers(null, sortedOverlays, {
				collapsed: $hasRoleCompanyManager ? false : true,
			}).addTo(map);

			// Create a Leaflet control for the legend and position it at the bottom right of the map
			const legend = L.control({
				position: 'bottomright',
			});

			// Create a div element with the class 'legend'
			const div = L.DomUtil.create('div', 'legend');

			// Define an array of colors and labels for the legend
			const color = ['#6ecb39', '#f0c10c', '#f08016'];
			const label = ['0-5', '5-10', '>10'];

			// Create an empty array to hold the rows of the legend
			const rows = [];

			// Define the onAdd method for the legend control
			legend.onAdd = function () {
				// For each color in the color array, create a row with a colored square and its corresponding label
				color.map((item, index) => {
					rows.push(`
						<div class="row" style="padding: 1px">
							<i style="background: ${item}"></i>${label[index]}
						</div>  
					`);
				});
				// Set the innerHTML of the legend div to the rows array joined into a string
				div.innerHTML = rows.join('');
				return div;
			};

			// Add the legend control to the map
			legend.addTo(map);
		}, 4000);
	});
</script>

<!-- If the map is still loading, display a loading indicator -->
{#if loadingMap}
	<MapLoading />
{/if}

<!-- Display the map and a list of layers -->
<div id="map" class="z-0"></div>
<ul class="layers"></ul>
